import React from 'react';
import { useDispatch } from 'react-redux';
import { useAppSelector } from '@hooks/reduxHooks';
import ArrowDawnIcon from '@icons/arrow-dawn-icon';
import ArrowDownIcon from '@icons/ArrowDownIconCrm';
import { useHouseCompact } from '@pages/roboto-calls/services/queries';
import { collectionClassNames } from '@pages/roboto-calls/utils/constants/call-collection';
import { setCollectionAudienceQueriesItem } from '@reducers/roboto-call-slice';
import { Empty, TreeSelect } from 'antd';
import { useTranslation } from 'react-i18next';

type Props = {
  index: number;
};

const HouseTreeSelect: React.FC<Props> = ({ index }) => {
  const { t } = useTranslation();
  const dispatch = useDispatch();
  const { houses, isLoading } = useHouseCompact(index);

  const { check, ids, subIds } = useAppSelector(
    ({
      robotoCallReducer: {
        audience: { queries }
      }
    }) => queries?.[index]
  );

  return (
    <TreeSelect
      multiple
      allowClear
      treeCheckable
      maxTagCount={1}
      disabled={!check}
      showSearch={false}
      loading={isLoading}
      maxTagTextLength={12}
      showCheckedStrategy="SHOW_ALL"
      placeholder={t('global.Tanlang')}
      treeIcon={() => <ArrowDawnIcon />}
      className={collectionClassNames.multiSelect}
      value={[...(ids || []), ...(subIds?.map(i => `sub-${i}`) || [])]}
      notFoundContent={<Empty description={t("global.Ma'lumotlar mavjud emas")} />}
      switcherIcon={({ expanded }: { expanded: boolean }) => (
        <ArrowDownIcon
          style={{
            transition: '0.3s ease-in-out',
            transform: `rotate(${expanded ? 0 : -90}deg)`
          }}
        />
      )}
      onClear={() => {
        dispatch(
          setCollectionAudienceQueriesItem({
            index,
            key: 'subIds',
            value: null
          })
        );

        dispatch(
          setCollectionAudienceQueriesItem({
            index,
            key: 'ids',
            value: null
          })
        );
      }}
      onChange={value => {
        dispatch(
          setCollectionAudienceQueriesItem({
            index,
            key: 'subIds',
            value: value?.filter(i => i?.includes('sub'))?.map(i => i?.split('-')?.[1])
          })
        );

        dispatch(
          setCollectionAudienceQueriesItem({
            index,
            key: 'ids',
            value: value?.filter(i => !i?.includes('sub'))
          })
        );
      }}
      treeData={houses?.map(({ id, buildings, name }) => ({
        value: `${id}`,
        label: name,
        children: buildings?.map(({ id, name }) => ({
          value: `sub-${id}`,
          label: name
        }))
      }))}
    />
  );
};

export default HouseTreeSelect;
